import { PERMISSIONS_URL } from "../common/constants";
import { GetSessionKeyResponse } from "../types/session-key-types";

export const getSessionKey = async(
    accountAddress: string,
    chainId: number,
    apiKey: string,
    sessionKey: string
): Promise<GetSessionKeyResponse> => {
    let response;

    if (!accountAddress) {
        throw new Error('Failed to lookup SessionKey in Backend - Account address is required');
    }

    if (!chainId) {
        throw new Error('Failed to lookup SessionKey in Backend - Chain ID is required');
    }

    if (!apiKey) {
        throw new Error('Failed to lookup SessionKey in Backend - API Key is required');
    }

    if (!sessionKey) {
        throw new Error('Failed to lookup SessionKey in Backend - Session Key is required');
    }

    try {
        let url = `${PERMISSIONS_URL}/account/getSessionKey?account=${accountAddress}&chainId=${chainId}&apiKey=${apiKey}&sessionKey=${sessionKey}`;

        response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            const responseJson: GetSessionKeyResponse = await response.json();
            return responseJson
        } else {
            const responseJson = await response.json();
            throw new Error(responseJson.message)
        }
    } catch (err) {
        throw new Error(err.message)
    }
}
